import { useState } from "react";
import { Loader2, Mail } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const EmailResumeLink = ({ reference }) => {
  const { user } = useAuth();
  const [email, setEmail] = useState(user?.email || "");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  async function send(e) {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post(`/whole-home/projects/${reference}/email-link`, { email });
      setSent(true);
      toast.success("Link sent — check your inbox.");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally { setBusy(false); }
  }

  if (sent) {
    return <p className="text-xs text-center text-[#2A5A3B] font-semibold" data-testid="resume-link-sent">Resume link sent to {email}</p>;
  }
  return (
    <form onSubmit={send} className="rounded-2xl border border-slate-200 bg-white p-3 space-y-2" data-testid="resume-link-form">
      <p className="text-xs font-semibold text-slate-700">Email me a link to pick this up later</p>
      <div className="flex gap-2">
        <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com"
          className="fm-input flex-1 min-w-0 h-10 text-sm" data-testid="resume-link-email" />
        <button type="submit" disabled={busy} className="h-10 px-3 rounded-full bg-[#0F3D2E] text-white text-sm font-semibold inline-flex items-center gap-1.5 shrink-0 disabled:opacity-60" data-testid="resume-link-send">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Mail className="w-4 h-4" />} Send
        </button>
      </div>
    </form>
  );
};
